var $dc578a950a2bf23d$exports = {};
$dc578a950a2bf23d$exports = {
  "decrease": function decrease(args) {
    return "Reduser ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\xD8k ".concat(args.fieldLabel);
  },
  "numberField": "Tallfelt"
};
export { $dc578a950a2bf23d$exports as default };